// extracted by mini-css-extract-plugin
export var container = "_6b-0";
export var fallback = "_6b-5";
export var fallbackIcon = "_6b-6";
export var hidden = "_6b-2";
export var image = "_6b-3";
export var loaded = "_6b-4";
export var placeholder = "_6b-1";